var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grotec-side-collapse side-collapse collapse",staticStyle:{"position":"fixed"}},[_c('departments-dropdown')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }